import { validateMatchSnapshot, normalizeSnapshot } from "./match-schema.js";

export function normalizeImportedMatch(raw) {
  return validateMatchSnapshot(normalizeSnapshot(raw));
}
